import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import Base from './input-base';
import { getMouseCoordinate } from '../../../fc-core/src/lib';

var InputSwipeGesture =
/*#__PURE__*/
function (_Base) {
  _inherits(InputSwipeGesture, _Base);

  function InputSwipeGesture() {
    var _this;

    _classCallCheck(this, InputSwipeGesture);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InputSwipeGesture).call(this));

    var a = _assertThisInitialized(_assertThisInitialized(_this));

    a.controlArr = [{
      nativeInteraction: ['fc-dragend'],
      callback: a.end.bind(a),
      component: a
    }, {
      nativeInteraction: ['fc-dragmove'],
      callback: a.move.bind(a),
      component: a
    }, {
      nativeInteraction: ['fc-dragstart'],
      callback: a.start.bind(a),
      component: a
    }];
    return _this;
  }

  _createClass(InputSwipeGesture, [{
    key: "getName",
    value: function getName() {
      return 'swipeGesture';
    }
  }, {
    key: "configure",
    value: function configure() {
      _get(_getPrototypeOf(InputSwipeGesture.prototype), "configure", this).call(this), this.enable();
    }
  }, {
    key: "getPresentScrollValue",
    value: function getPresentScrollValue() {
      var a = this,
          b = a.config.xAxis,
          c = b.getVisibleConfig(),
          d = b.getLimit(),
          e = c.maxValue - c.minValue,
          f = d.max - d.min;
      return (c.minValue - d.min) / (f - e);
    }
  }, {
    key: "start",
    value: function start(a) {
      var b,
          c,
          d = this,
          e = d.getFromEnv('chart'),
          f = d.config;
      b = getMouseCoordinate(e.getFromEnv('chart-container'), a.originalEvent, e), f.previousX = b.chartX, f.presentScrollValue = c = d.getPresentScrollValue(), e.fireChartInstanceEvent('scrollStart', {
        scrollPosition: c
      });
    }
  }, {
    key: "move",
    value: function move(a) {
      var b,
          c = this,
          d = c.config,
          e = c.getFromEnv('chart'),
          f = d.xAxis,
          g = f.getChildren('scrollBar') && f.getChildren('scrollBar')[0],
          h = g && g.getChildren('scrollAnchor')[0],
          i = f.config.axisRange,
          j = getMouseCoordinate(e.getFromEnv('chart-container'), a.originalEvent, e),
          k = j.chartX,
          l = (k - d.previousX) / d.plotDifference,
          m = f.getVisibleConfig(),
          n = d.previousScrollValue = d.presentScrollValue,
          o = m.minValue - l,
          p = d.axisMin,
          q = d.axisMax,
          r = m.maxValue - l;
      o < p && p === m.minValue || r > q && q === m.maxValue || (o < p ? (r += l, l = m.minValue - p, r -= l, o = p) : q < r && (o += l, l = q - m.maxValue, o += l, r = q), b = (o - i.min) / (i.max - i.min - (r - o)), h.config.scrollPosition = b, e.getFromEnv('animationManager').setAnimationState('scroll'), f.setVisibleConfig(o, r), e.fireChartInstanceEvent('onScroll', {
        scrollPosition: n
      }), d.previousX = k, d.presentScrollValue = c.getPresentScrollValue());
    }
  }, {
    key: "end",
    value: function end() {
      var a = this,
          b = a.config,
          c = a.getFromEnv('chart');
      c.fireChartInstanceEvent('scrollEnd', {
        previousScrollPosition: b.previousScrollValue,
        scrollPosition: b.presentScrollValue
      });
    }
  }, {
    key: "setControl",
    value: function setControl() {
      var a = this,
          b = a.getLinkedParent(),
          c = a.controlArr;
      b.releaseControl(c), a.isEnabled() && b.getControl(c);
    }
  }, {
    key: "draw",
    value: function draw() {
      var a = this,
          b = a.config,
          c = a.getFromEnv('canvas').getAxes().filter(function (a) {
        return !a.isY;
      }),
          d = b.xAxis = c && c[0] && c[0].axis,
          e = d.config.axisRange;
      b.plotDifference = d.getPixel(1) - d.getPixel(0), b.axisMin = e.min, b.axisMax = e.max;
    }
  }]);

  return InputSwipeGesture;
}(Base);

export default InputSwipeGesture;